import React from 'react';

const FormField = ({
  label,
  required = false,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  disabled = false,
  maxLength,
  rows,
  className = '',
  showCharCount = false,
  options = [],
  helpText,
  autoComplete,
  minLength,
  ...props
}) => {
  const inputClassName = `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
    error ? 'border-red-300' : 'border-gray-300'
  } ${disabled ? 'bg-gray-50 text-gray-500' : ''} ${className}`;

  const renderInput = () => {
    if (type === 'select') {
      return (
        <select
          value={value}
          onChange={onChange}
          className={inputClassName}
          disabled={disabled}
          required={required}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }
    
    if (type === 'textarea') {
      return (
        <textarea
          value={value}
          onChange={onChange}
          className={inputClassName}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          rows={rows}
          required={required}
          {...props}
        />
      );
    }
    
    return (
      <input
        type={type}
        value={value}
        onChange={onChange}
        className={inputClassName}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        required={required}
        autoComplete={autoComplete}
        minLength={minLength}
        {...props}
      />
    );
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {renderInput()}
      {helpText && (
        <p className="text-xs text-gray-500 mt-1">{helpText}</p>
      )}
      {error && (
        <p className="text-sm text-red-600 mt-1">{error}</p>
      )}
      {showCharCount && maxLength && (
        <p className="text-xs text-gray-500 mt-1">
          {value?.length || 0}/{maxLength} characters
        </p>
      )}
    </div>
  );
};

export default FormField;